/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'

/**
 * Typescript enum
 */

export enum NotificationTargetGroup {
  PRODUCTION = 'PRODUCTION',
  TESTING = 'TESTING'
}

/**
 * NotificationTargetGroup
 *
 * The different target groups to send notifications to
 */
export const NotificationTargetGroupEnumType = types.enumeration('NotificationTargetGroup', ['PRODUCTION', 'TESTING'])
